import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";
import { cn } from "../../lib/utils.js";
import { SettingsPageHeader } from "./SettingsPageHeader.js";

export function SettingsSectionPage({
  title,
  description,
  icon,
  testId,
  actions,
  contentClassName,
  children,
}: {
  title: string;
  description: string;
  icon: LucideIcon;
  testId: string;
  actions?: ReactNode;
  contentClassName?: string;
  children?: React.ReactNode;
}): React.JSX.Element {
  return (
    <div className="flex h-full min-h-0 flex-col overflow-hidden" data-testid={testId}>
      <SettingsPageHeader
        icon={icon}
        title={title}
        description={description}
        actions={actions}
      />
      <div
        className={cn(
          "min-h-0 flex-1 overflow-y-auto px-4 py-6 [scrollbar-gutter:stable] md:px-8 md:py-7",
          contentClassName,
        )}
      >
        {children}
      </div>
    </div>
  );
}
